var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                staticStyle: {
                  width: "100%",
                  "min-width": "160px",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        { ref: "cargoButtonGroupSlider" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "look",
                                  expression: "action==='look'"
                                }
                              ],
                              class:
                                "btn-group-look" +
                                (_vm.canOperateJob ? "" : " cannot-operate-job")
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "can-operate",
                                  attrs: { no: "back", type: "primary" },
                                  on: { click: _vm.goBack }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.user.admin ||
                                        !_vm.$checkPermission([
                                          "role_ElectricBusiness"
                                        ]),
                                      expression:
                                        "user.admin||!$checkPermission(['role_ElectricBusiness'])"
                                    }
                                  ],
                                  attrs: {
                                    disabled: !(
                                      Number(_vm.currentRow.jobState) === 0 &&
                                      !_vm.JobUtils.isBlockJob(_vm.currentRow)
                                    ),
                                    no: "edit",
                                    type: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editEventFlag = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [_vm.addButtonPermission],
                                      expression: "[addButtonPermission]"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "new",
                                    disabled: _vm.hqDisabledOperate,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addHandler()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showAddHblButton,
                                      expression: "showAddHblButton"
                                    },
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [_vm.addButtonPermission],
                                      expression: "[addButtonPermission]"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "new",
                                    disabled: _vm.hqDisabledOperate,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addHandler({
                                        masterFlag: true
                                      })
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.AddHbl")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [_vm.addButtonPermission],
                                      expression: "[addButtonPermission]"
                                    }
                                  ],
                                  attrs: { no: "Copy", type: "primary" },
                                  on: { click: _vm.toCopy }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.$checkPermission([
                                          "button_JobBooking_ReturnReview"
                                        ]) && _vm.showReturnReview,
                                      expression:
                                        "$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                                    }
                                  ],
                                  attrs: {
                                    no: "returnReview",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.returnReview()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ReturnPreApprovalRemoteBooking"
                                      )
                                    )
                                  )
                                ]
                              ),
                              (_vm.currentRow.shutOut
                              ? _vm.button_IEBooking_cancelShutout
                              : _vm.button_IEBooking_Shutout)
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "toShutOut",
                                        type: "primary",
                                        disabled:
                                          !(
                                            _vm.currentRow.jobState ===
                                              _vm.SystemConstants.OPERATING ||
                                            _vm.currentRow.jobState ===
                                              _vm.SystemConstants.SHUT_OUT
                                          ) || _vm.isCooperate
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.toShutOut()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentRow.shutOut
                                            ? _vm.$t("SeaExport.CancelShutOut")
                                            : _vm.$t("SeaExport.ShutOut")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.enablePrint,
                                    no: "print",
                                    type: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onPrint()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                              ),
                              !_vm.currentRow.masterFlag
                                ? _c(
                                    "el-button",
                                    {
                                      class:
                                        _vm.btnInfo.btnEntrustment ===
                                        _vm.$t(
                                          "SeaExport.AssociationBusinessInformation"
                                        )
                                          ? "can-operate"
                                          : "",
                                      attrs: {
                                        no: "btnEntrustment",
                                        type: "primary",
                                        disabled: !(
                                          _vm.btnInfo.consignationEnable &&
                                          _vm.$store.getters.isGroupCompany
                                        )
                                      },
                                      on: { click: _vm.consignationHandler }
                                    },
                                    [_vm._v(_vm._s(_vm.btnInfo.btnEntrustment))]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.preSubmitVisible,
                                      expression: "preSubmitVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "PreSubmission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.doPreSubmit()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PreSubmission"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.submitVisible,
                                      expression: "submitVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "Submission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.doSubmit()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Submission")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.managerSubmitVisible,
                                      expression: "managerSubmitVisible"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "ManagerSubmission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.doManagerSubmit()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ManagerSubmission")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.submitAuditVisible,
                                      expression: "submitAuditVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "Audit",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.doSubmitAudit_ManagerSubmit()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Audit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentRow.jobState ===
                                          _vm.SystemConstants.PRE_COMMIT &&
                                        _vm.$checkPermission([
                                          "button_JobBooking_ReturnToOperater"
                                        ]),
                                      expression:
                                        "currentRow.jobState === SystemConstants.PRE_COMMIT && $checkPermission(['button_JobBooking_ReturnToOperater'])"
                                    }
                                  ],
                                  attrs: {
                                    no: "ReturnAction",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.backReturn()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ReturnAction"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentRow.jobState ===
                                          _vm.SystemConstants.COMMITED &&
                                        _vm.$checkPermission([
                                          "button_JobBooking_Retract"
                                        ]),
                                      expression:
                                        "currentRow.jobState === SystemConstants.COMMITED && $checkPermission(['button_JobBooking_Retract'])"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "PrintReturn",
                                    type: "primary",
                                    disabled:
                                      _vm.isCooperate || _vm.controlledLocked
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.backReturn()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PrintReturn"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        (!_vm.orderCenterBranch ||
                                          (_vm.orderCenterBranch &&
                                            _vm.useOrderCenterBranch &&
                                            !_vm.isRegionalCommission)),
                                      expression:
                                        "useOrderCenterMode && !masterFlag && (!orderCenterBranch || (orderCenterBranch && useOrderCenterBranch && !isRegionalCommission))"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperation",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Cooperation"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        !_vm.orderCenterBranch,
                                      expression:
                                        "useOrderCenterMode && !masterFlag && !orderCenterBranch"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperationReturn",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationReturnHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CooperationReturn")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown",
                                {
                                  staticClass: "can-operate",
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    no: "logHandle",
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.logHandle()
                                    },
                                    command: function(p) {
                                      _vm.logCommand = p
                                      _vm.pm.logHandle()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_LogRecord")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "CargoMsg.Cargo_BusinessStatusChangeLog"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_BusinessStatusChangeLog"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isNew,
                                  expression: "isNew"
                                }
                              ],
                              staticClass: "new btn-group-new",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "save", type: "success" },
                                  on: { click: _vm.save }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "cancel", type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelEdit(_vm.goBack)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "SaveTheDefaultValues",
                                    type: "primary"
                                  },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "edit",
                                  expression: "action==='edit'"
                                }
                              ],
                              staticClass: "btn-group-edit",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "save2", type: "success" },
                                  on: { click: _vm.save }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "cancel2", type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelEdit(_vm.lookHandler)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "SaveTheDefaultValues2",
                                    type: "primary"
                                  },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.action === "look" || _vm.action === "edit",
                          expression: "action==='look'||action==='edit'"
                        }
                      ],
                      staticClass: "triggers-right"
                    },
                    [
                      _c("CargoIm", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.imCacheKey && _vm.action === "look",
                            expression: "imCacheKey && action==='look'"
                          }
                        ],
                        ref: "cargoIm"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content:
                              _vm.action === "edit"
                                ? ""
                                : _vm.$t("SeaExport.Tip1"),
                            placement: "bottom-start",
                            offset: _vm.sopTooltipOffset,
                            "visible-arrow": false
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { width: "100%", cursor: "pointer" },
                              on: {
                                mousemove: _vm.resetSopTooltip,
                                dblclick: _vm.onBtnListDoubleClicked
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "red",
                                    padding: "5px 0"
                                  },
                                  attrs: { no: "SopState" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.stateInfo.jobState) + " "
                                  ),
                                  (Number(_vm.currentRow.jobState) === 0 ||
                                    Number(_vm.currentRow.jobState) === 1 ||
                                    Number(_vm.currentRow.jobState) === 2 ||
                                    Number(_vm.currentRow.jobState) === 11) &&
                                  _vm.currentRow.shutOut &&
                                  !_vm.stateInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticClass: "red",
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "Message.HasChargeToShutOut"
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  (Number(_vm.currentRow.jobState) === 0 ||
                                    Number(_vm.currentRow.jobState) === 1 ||
                                    Number(_vm.currentRow.jobState) === 2 ||
                                    Number(_vm.currentRow.jobState) === 11) &&
                                  _vm.currentRow.shutOut &&
                                  _vm.stateInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticClass: "red",
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "Message.HasChargeToShutOut"
                                                )
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.stateInfo.jobChangeState
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  !(
                                    (Number(_vm.currentRow.jobState) === 0 ||
                                      Number(_vm.currentRow.jobState) === 1 ||
                                      Number(_vm.currentRow.jobState) === 2 ||
                                      Number(_vm.currentRow.jobState) === 11) &&
                                    _vm.currentRow.shutOut
                                  ) && _vm.stateInfo.jobChangeState
                                    ? _c(
                                        "font",
                                        {
                                          staticClass: "red",
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.stateInfo.jobChangeState
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.job.payableChargeLockedStatus === 1
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "red",
                                        padding: "5px 0 5px 9px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_PayableLockedStatusTag"
                                          )
                                        )
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              _vm.payableChargeLockedTooltip,
                                            placement: "bottom",
                                            "visible-arrow": false
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning",
                                            staticStyle: { cursor: "pointer" }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("span", {
                                staticStyle: {
                                  "font-size": "12px",
                                  padding: "5px 9px",
                                  color: "unset"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.stateInfo.jobTitle)
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "red",
                                    padding: "5px 0"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.stateInfo.jobLock))]
                              ),
                              _vm.stateInfo.provisionLock &&
                              _vm.stateInfo.provisionLock.etdLocked
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "red",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [_vm._v("计提已校准")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm.currentRow.zyCreditWarning
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.currentRow.zyCreditWarning,
                                placement: "bottom-start",
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "right-tip",
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "12px",
                                    color: "orange",
                                    width: "250px",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "white-space": "nowrap"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentRow.zyCreditWarning)
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  class:
                    "tabs-container" +
                    (_vm.canOperateJob ? "" : " cannot-operate-job")
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _vm.paramsOfTab.containerLoadType === "TT"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabGatheringTrailerBase",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable &&
                              _vm.integratedLogisticsType &&
                              _vm.integratedLogisticsType === "TT"
                                ? _c("tab-gathering-trailer-base-UICustom", {
                                    ref: "tabGatheringTrailerBase",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                                : _c("tab-gathering-trailer-base", {
                                    ref: "tabGatheringTrailerBase",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "CL"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabLessThanCarloadBase",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable &&
                              _vm.integratedLogisticsType &&
                              _vm.integratedLogisticsType === "CL"
                                ? _c("tab-less-than-carload-base-UICustom", {
                                    ref: "tabLessThanCarloadBase",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                                : _c("tab-less-than-carload-base", {
                                    ref: "tabLessThanCarloadBase",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "IC" &&
                      !_vm.paramsOfTab.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 17,
                              attrs: {
                                lazy: true,
                                name: "tabInternationalCard",
                                label: _vm.$t("CargoMsg.Cargo_IC")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable &&
                              _vm.integratedLogisticsType &&
                              _vm.integratedLogisticsType === "IC"
                                ? _c("tab-international-card-base-UICustom", {
                                    ref: "tabInternationalCard",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.stateInfo.provisionLock
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                                : _c("tab-international-card-base", {
                                    ref: "tabInternationalCard",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.stateInfo.provisionLock
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "IC" &&
                      _vm.paramsOfTab.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 17,
                              attrs: {
                                lazy: true,
                                name: "tabInternationalCardMaster",
                                label: _vm.$t("CargoMsg.Cargo_IC")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable &&
                              _vm.integratedLogisticsType &&
                              _vm.integratedLogisticsType === "IC"
                                ? _c(
                                    "tab-international-card-base-master-UICustom",
                                    {
                                      ref: "tabInternationalCardMaster",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "cooperate-edit":
                                          _vm.cooperateEditOther,
                                        "integrated-logistics-type":
                                          _vm.integratedLogisticsType,
                                        "processing-promise-list":
                                          _vm.processingPromiseList,
                                        "template-name": _vm.templateName
                                      },
                                      on: {
                                        resetTab: _vm.resetTab,
                                        addSlavedJob: _vm.addSlavedJob,
                                        removeJobFromMaster:
                                          _vm.removeJobFromMaster,
                                        containerLoadTypeEvent:
                                          _vm.containerLoadTypeEvent
                                      }
                                    }
                                  )
                                : _c("tab-international-card-base-master", {
                                    ref: "tabInternationalCardMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "integrated-logistics-type":
                                        _vm.integratedLogisticsType,
                                      "processing-promise-list":
                                        _vm.processingPromiseList
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "IC" &&
                      _vm.tabOrderCar
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 18,
                              attrs: {
                                lazy: true,
                                name: "tabOrderCar",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _c("tab-order-car", {
                                ref: "tabOrderCar",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "IC" &&
                      _vm.paramsOfTab.landTransportation &&
                      _vm.tabDoorInformation
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 19,
                              attrs: {
                                lazy: true,
                                name: "tabDoorInformation",
                                label: _vm.$t("Partners.doorInformation")
                              }
                            },
                            [
                              _c("tab-less-than-carload", {
                                ref: "tabDoorInformation",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "IC" &&
                      _vm.paramsOfTab.dischargingPortDoor &&
                      _vm.tabDestinationDelivery
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                lazy: true,
                                name: "tabDestinationDelivery",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_DestinationDelivery"
                                )
                              }
                            },
                            [
                              _c("tab-destination-delivery", {
                                ref: "tabDestinationDelivery",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "TT"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabGatheringTrailer",
                                label: _vm.$t("SeaExport.GatheringTrailer")
                              }
                            },
                            [
                              _c("tab-gathering-trailer", {
                                ref: "tabGatheringTrailer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "CL"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabLessThanCarload",
                                label: _vm.$t(
                                  "SeaExport.WholeVehicleLessThanCarload"
                                )
                              }
                            },
                            [
                              _c("tab-less-than-carload", {
                                ref: "tabLessThanCarload",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType === "TT"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: {
                                  clearSeaEqList: _vm.clearSeaEqListHandler
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType !== "IC" ||
                      (_vm.paramsOfTab.containerLoadType === "IC" &&
                        _vm.paramsOfTab.warehousing)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouse",
                                label: _vm.$t("SeaExport.WarehouseLoading")
                              }
                            },
                            [
                              _c("tab-warehouse", {
                                ref: "tabWarehouse",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditWarehouse
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.containerLoadType !== "CL"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouseIn",
                                label: _vm.$t("SeaExport.CargoInfo")
                              }
                            },
                            [
                              _c("tab-warehouse-in", {
                                ref: "tabWarehouseIn",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { refreshTabs: _vm.refresh }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.customs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _c("tab-customs-info", {
                                ref: "tabCustomsInfo",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditCustoms
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.insure
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                name: "tabInsure",
                                label: _vm.$t("SeaExport.InsureInfo")
                              }
                            },
                            [
                              _c("tab-insure", {
                                ref: "tabInsure",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabTradeDetail",
                                label: _vm.$t("SeaExport.TradeDetail")
                              }
                            },
                            [
                              _c("tab-trade-detail", {
                                ref: "tabTradeDetail",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "IeBooking",
                                  "provision-lock": _vm.stateInfo.provisionLock
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew && _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "IeBooking"
                                },
                                on: { refreshCharges: _vm.refreshCharges }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      !_vm.isNew &&
                      _vm.privilege.charge.advanceCharge
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabAdvanceCharge",
                                label: _vm.$t("SeaExport.AdvanceChargeInfo")
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "tabFile",
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.privilege.ieBooking.portalState && !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "controlled-locked": _vm.controlledLocked,
                                  "sop-template-config": _vm.sopTemplateConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      !_vm.isNew &&
                      _vm.privilege.fileHistory.fileHistoryView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 16,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "can-operate-job": _vm.canOperateJob,
                                  "controlled-locked": _vm.controlledLocked
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "shutOut",
            visible: _vm.shutOutDialog.visible,
            title: _vm.$t("Message.Warning"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.shutOutDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "padding-left": "30px"
              }
            },
            [
              _c("span", { staticStyle: { "line-height": "40px" } }, [
                _vm._v(_vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")))
              ]),
              _c("span", { staticStyle: { "line-height": "18px" } }, [
                _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
              ]),
              _c("span", { staticStyle: { "line-height": "18px" } }, [
                _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
              ])
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "HasChargeToShutOut", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.pm.hasChargeShutoutHandler()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
              ),
              _c(
                "el-button",
                {
                  style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                  attrs: { no: "NoChargeToShutOut", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.pm.noHasChargeShutoutHandler()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.shutOutDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.action !== "look",
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          job: _vm.currentRow,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedRefresh": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
          },
          "update:is-need-refresh": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _c("estimate-validation-dialog", {
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: "IE",
              job: _vm.currentRow,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                no: "DataPushChangeLog",
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "580px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c("div", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm.businessStatusDialog.visible
        ? _c("business-status-log-dialog", {
            attrs: {
              visible: _vm.businessStatusDialog.visible,
              "job-uuid": _vm.currentRow.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.businessStatusDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationBranchListDialog.visible
        ? _c("cooperation-branch-list", {
            attrs: {
              visible: _vm.cooperationBranchListDialog.visible,
              "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
              job: _vm.cooperationBranchListDialog.job,
              "order-center-branch":
                _vm.cooperationBranchListDialog.orderCenterBranch
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cooperationBranchListDialog,
                  "visible",
                  $event
                )
              },
              refresh: function(cooperatebranch) {
                _vm.updateJobCooperate(cooperatebranch)
                this$1.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)
              },
              cancel: function() {
                return (_vm.cooperationBranchListDialog.visible = false)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: "IE",
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.sendBranchWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.sendBranchWindow.visible,
                title: _vm.sendBranchWindow.title,
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + ":" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.sendBranchWindow.office.officeId,
                            category: "role",
                            shape: "op"
                          }
                        },
                        on: {
                          change: function(p) {
                            _vm.sendBranchWindow.userId = p.value
                            _vm.userId_changeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showdCheckSalesMapping
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("queryJob.SalesMapping") } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "checkSalesMapping" },
                              model: {
                                value: _vm.sendBranchWindow.checkSalesMapping,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sendBranchWindow,
                                    "checkSalesMapping",
                                    $$v
                                  )
                                },
                                expression: "sendBranchWindow.checkSalesMapping"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.SalesCargoSalesMap"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.enterSendHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.sendBranchWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "IE",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "detail"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.refresh
        }
      }),
      _vm.trustFromWindow.visible
        ? _c("trust-from-window", {
            ref: "trustFromWindow",
            attrs: {
              visible: _vm.trustFromWindow.visible,
              "trust-job": _vm.trustFromWindow.trustJob,
              job: _vm.trustFromWindow.job,
              context: _vm.context,
              "can-operate-job": _vm.canOperateJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.trustFromWindow, "visible", $event)
              },
              refresh: _vm.refresh
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }